module.exports = __webpack_public_path__ + "static/media/swiftly.d8d435aa.mp3";